import React from 'react'
import './Community.css'

function Community() {
    return (
        <div className='community'>
            <h1>Community</h1>
             <h5>Coming soon</h5>
        </div>
    )
}

export default Community
